"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unloadStyles = exports.filesAppender = exports.tagAppender = exports.createScriptElement = exports.createLinkElement = void 0;
const ModuleRegistry_1 = require("./ModuleRegistry");
const ReactModuleContainerErrors_1 = require("./ReactModuleContainerErrors");
function noprotocol(url) {
    return url.replace(/^.*:\/\//, '//');
}
function createLinkElement(url) {
    const fileref = document.createElement('link');
    fileref.setAttribute('rel', 'stylesheet');
    fileref.setAttribute('type', 'text/css');
    fileref.setAttribute('href', url);
    return fileref;
}
exports.createLinkElement = createLinkElement;
function createScriptElement(url, crossorigin) {
    const fileref = document.createElement('script');
    fileref.setAttribute('type', 'text/javascript');
    fileref.setAttribute('src', url);
    if (crossorigin) {
        fileref.setAttribute('crossorigin', 'anonymous');
    }
    return fileref;
}
exports.createScriptElement = createScriptElement;
function tagAppender(url, filetype, crossorigin) {
    const styleSheets = document.styleSheets;
    return new Promise((resolve, reject) => {
        // @ts-expect-error
        if (window.requirejs && filetype === 'js') {
            // @ts-expect-error
            window.requirejs([url], resolve, reject);
            return;
        }
        const fileref = filetype === 'css' ? createLinkElement(url) : createScriptElement(url, crossorigin);
        let done = false;
        document.getElementsByTagName('head')[0].appendChild(fileref);
        fileref.onerror = function () {
            // @ts-expect-error
            fileref.onerror = fileref.onload = fileref.onreadystatechange = null;
            (0, ModuleRegistry_1.getModuleRegistry)().notifyListeners('reactModuleContainer.error', new ReactModuleContainerErrors_1.FileAppenderLoadError(url));
            reject(new Error(`Could not load URL ${url}`));
        };
        // @ts-expect-error
        fileref.onload = fileref.onreadystatechange = function () {
            if (!done && (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete')) {
                done = true;
                // @ts-expect-error
                fileref.onerror = fileref.onload = fileref.onreadystatechange = null;
                resolve();
            }
        };
        if (filetype === 'css' &&
            navigator.userAgent.match(' Safari/') &&
            !navigator.userAgent.match(' Chrom') &&
            navigator.userAgent.match(' Version/5.')) {
            let attempts = 20;
            const interval = setInterval(() => {
                // eslint-disable-next-line @typescript-eslint/prefer-for-of
                for (let i = 0; i < styleSheets.length; i++) {
                    if (noprotocol(`${styleSheets[i].href}`) === noprotocol(url)) {
                        clearInterval(interval);
                        // @ts-expect-error
                        fileref.onload();
                        return;
                    }
                }
                if (--attempts === 0) {
                    clearInterval(interval);
                    // @ts-expect-error
                    fileref.onerror();
                }
            }, 50);
        }
    });
}
exports.tagAppender = tagAppender;
function append(file, crossorigin) {
    return tagAppender(file, file.split('.').pop(), crossorigin);
}
function onCatch(error, optional = false) {
    return optional ? Promise.resolve() : Promise.reject(error);
}
function appendEntry(entry, crossorigin) {
    if (typeof entry === 'object') {
        const { optional, url } = entry;
        return append(url, crossorigin).catch((err) => onCatch(err, optional));
    }
    return append(entry, crossorigin).catch((err) => onCatch(err));
}
function filesAppender(entries, crossorigin) {
    return Promise.all(entries.map((entry) => {
        if (Array.isArray(entry)) {
            return entry.reduce((promise, _entry) => promise.then(() => appendEntry(_entry, crossorigin)), Promise.resolve());
        }
        return appendEntry(entry, crossorigin);
    }));
}
exports.filesAppender = filesAppender;
const getStyleSheetLinks = (document) => [...document.querySelectorAll('link')]
    .filter((link) => link.rel === 'stylesheet' && link.href)
    .reduceRight((acc, curr) => (Object.assign(Object.assign({}, acc), { [noprotocol(curr.href)]: curr })), {});
const toUrlString = (file) => (typeof file === 'object' ? file.url : file);
const getStyleSheetUrls = (files) => []
    .concat(...files)
    .map(toUrlString)
    .filter((url) => url.endsWith('.css'))
    .map(noprotocol);
function unloadStyles(document, files) {
    const links = getStyleSheetLinks(document);
    getStyleSheetUrls(files).forEach((file) => {
        const link = links[file];
        if (link) {
            link.parentNode.removeChild(link);
        }
    });
}
exports.unloadStyles = unloadStyles;
//# sourceMappingURL=tag-appender.js.map